let root;

export default {
  install(Vue, options) {
    Vue.prototype.$tpNav = {
      setVue(_vue) {
        root = _vue
      },
      showProjectList(client) {
        root.$root.$emit('SearchResults::toggle', false)
        root.$root.$emit('ClientList::move', 'left-100')
        root.$root.$emit('ProjectView::move', 'right-100')
        root.$root.$emit('ClientProjects::show', client)
        this.scrollTop()
      },
      showProjectView(project) {
        root.$root.$emit('SearchResults::toggle', false)
        root.$root.$emit('ClientList::move', 'left-100')
        root.$root.$emit('ClientProjects::move', 'left-100')
        root.$root.$emit('ProjectView::show', project)
        this.scrollTop()
      },
      scrollTop() {
        document.getElementsByClassName('project-task-pool')[0].scroll({top: 0, behavior: 'smooth'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/agenda-v2/task-pool/TaskPoolNav.js